import dayjs from 'dayjs';
export function findClosestEventDate(timelineEvents) {
    var now = dayjs();
    return timelineEvents.filter(function (event) {
        return (event.startDate.isSame(now, 'day') &&
            event.startDate.isSame(now, 'month') &&
            event.startDate.isSame(now, 'year')) ||
            event.startDate.isAfter(now);
    });
}
export function compareEventTimelineDate(timelineEvent, compareTimelineEvent) {
    if (timelineEvent.endDate) {
        return ((timelineEvent.startDate.isSame(compareTimelineEvent) ||
            timelineEvent.startDate.isBefore(compareTimelineEvent)) &&
            (timelineEvent.endDate.isAfter(compareTimelineEvent) || timelineEvent.endDate.isSame(compareTimelineEvent)));
    }
    return timelineEvent.startDate.isSame(compareTimelineEvent, 'day');
}
export function findHighlightEvents(timelineEvents) {
    /**
     * 1. filter out past exact date events
     * 2. filter out past range events
     * 3. concat upcoming dates
     * 4. sort upcoming dates
     * 5. find exact date match
     * 6. find matching date ranges
     * 7. concat result of exact date matches and date range matches
     */
    var now = dayjs();
    var upcomingExactDateEvents = timelineEvents.filter(function (timelineEvent) { return timelineEvent.endDate === null && timelineEvent.startDate.isAfter(now); });
    var currentRangeEvents = timelineEvents
        .filter(function (timelineEvent) { return timelineEvent.endDate !== null; })
        .filter(function (rangeTimelineEvent) { var _a; return (_a = rangeTimelineEvent.endDate) === null || _a === void 0 ? void 0 : _a.isAfter(now); });
    var upcomingEvents = upcomingExactDateEvents.concat(currentRangeEvents);
    upcomingEvents.sort(function (a, b) {
        var valA = a.startDate.unix();
        var valB = b.startDate.unix();
        if (valA > valB) {
            return 1;
        }
        else if (valA < valB) {
            return -1;
        }
        return 0;
    });
    var todaysEvents = upcomingEvents
        .filter(function (upcomingEvent) { return upcomingEvent.endDate === null; })
        .filter(function (upcomingEvent) { return upcomingEvent.startDate.isSame(now, 'date'); });
    var currentRangedEvents = upcomingEvents
        .filter(function (upcomingEvent) { return upcomingEvent.endDate !== null; })
        .filter(function (upcomingRangeEvent) {
        return (upcomingRangeEvent.startDate.isSame(now, 'date') || upcomingRangeEvent.startDate.isBefore(now, 'date')) &&
            upcomingRangeEvent.endDate.isAfter(now, 'date');
    });
    var currentAndUpcomingEvents = todaysEvents.concat(currentRangedEvents);
    return currentAndUpcomingEvents;
}
//# sourceMappingURL=utils.js.map